/**
 * Format ticket payment amounts (default LKR with thousands separators).
 */
export function formatTicketMoney(amount, currency = 'LKR', options = {}) {
  const value = Number(amount) || 0;
  const code = String(currency || 'LKR').trim().toUpperCase() || 'LKR';
  const minimumFractionDigits = options.minimumFractionDigits ?? 2;
  const maximumFractionDigits = options.maximumFractionDigits ?? 2;

  try {
    return new Intl.NumberFormat('en-LK', {
      style: 'currency',
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value);
  } catch {
    const formatted = value.toLocaleString('en-LK', {
      minimumFractionDigits,
      maximumFractionDigits,
    });
    return `${code} ${formatted}`;
  }
}

/** Whole-number ticket list prices (e.g. type catalog). */
export function formatTicketPrice(amount, currency = 'LKR') {
  return formatTicketMoney(amount, currency, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
